import { render, staticRenderFns } from "./ButtonResponse.vue?vue&type=template&id=dca95a3c&scoped=true&"
import script from "./ButtonResponse.vue?vue&type=script&lang=js&"
export * from "./ButtonResponse.vue?vue&type=script&lang=js&"
import style0 from "./ButtonResponse.vue?vue&type=style&index=0&id=dca95a3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca95a3c",
  null
  
)

export default component.exports